<form>
    <mat-form-field>
      <mat-label>{{modeConfig[autocompleteMode()].label}}</mat-label>
      @let displayNameWith = modeConfig[autocompleteMode()].nameFn;
      <input type="text"
             placeholder="Type 3 characters or more..."
             [ariaLabel]="modeConfig[autocompleteMode()].label"
             matInput
             [value]=""
             [formControl]="autocompleteInnerControl"
             [matAutocomplete]="autocompleteRef"
             (input)="inputValueCheck()"> 
        <mat-autocomplete 
            #autocompleteRef="matAutocomplete"
            [displayWith]="displayNameWith"
            (optionSelected)='setValue($event.option.value)'>
            @let options = filteredOptions$ | async;
            @for (option of options; track option?.id) {
                <mat-option [value]="option">{{displayNameWith(option)}}</mat-option>
            }   
        </mat-autocomplete>
        @if(autocompleteInnerControl.value && !hideClearButton()){
            <button matSuffix mat-icon-button
                type="button"
                title="Clear profile"
                (click)="clearAutocomplete(autocompleteRef); $event.stopPropagation()">
                    <mat-icon>close</mat-icon>
            </button>
        }
        @if (autocompleteInnerControl.hasError('invalidModel')) {
            <mat-error>Type and select an option</mat-error>
        }
    </mat-form-field>
</form>